import useSwr from "swr";
import { LateFeeApi } from "../apis/late-fee";

/** Single shared SWR cache for seller late-fee config (list + drawers). */
export function useLateFeeConfig() {
  const { data, isLoading, error, mutate } = useSwr(
    "swr.late-fee-config",
    () => LateFeeApi.getConfig(),
    { revalidateOnFocus: false },
  );

  const lateFeeEnabled = !!(data as any)?.config?.lateFeeEnabled;

  return { lateFeeEnabled, isLoading, error, data, mutate };
}
